// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"tabs_mulitpleDropdown__3ri0_","menuWrapper":"tabs_menuWrapper__30UIh"};